/**
 * TagRegisterPresenter
 * --
 */
import { useState } from 'react';
import {
  Content,
  Title,
  Row,
  Col,
} from 'components';
import { TagRegisterContent, TagList, ProductTable } from './components';
import { styles } from './styles'

const TagRegisterPresenter = ({ tagList }) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [selectedTag, setSelectedTag] = useState({});
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  const handleUpdateTag = (tag) => {

  }
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Row>
        <Col x={24}>
          <Title style={{ ...styles.title }}>태그 등록/수정</Title>

        {/* 태그 생성 */}
          <TagRegisterContent tagList={tagList} />
          {/* 태그 생성 끝 */}

          {/* 태그 상품 등록 */}
          <Row gutter={[10, 10]}>
            <Col x={6}>
              <TagList 
                tagList={tagList} 
                selectedTag={selectedTag} 
                onChangeSelectedTag={(tag) => setSelectedTag(tag)}
                onUpdateTag={(tag) => handleUpdateTag(tag)}
              />
            </Col>
            <Col x={18}>
              <ProductTable selectedTag={selectedTag} />
            </Col>
          </Row>
          {/* 태그 상품 등록 끝 */}
        </Col>
      </Row>
    </Content>
  );
};

export default TagRegisterPresenter;
